/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScreenerSetting
 */
export interface ScreenerSetting {
    /**
     * 
     * @type {string}
     * @memberof ScreenerSetting
     */
    setting_name: string;
    /**
     * 
     * @type {string}
     * @memberof ScreenerSetting
     */
    value: string;
}

/**
 * Check if a given object implements the ScreenerSetting interface.
 */
export function instanceOfScreenerSetting(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "setting_name" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function ScreenerSettingFromJSON(json: any): ScreenerSetting {
    return ScreenerSettingFromJSONTyped(json, false);
}

export function ScreenerSettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerSetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'setting_name': json['setting_name'],
        'value': json['value'],
    };
}

export function ScreenerSettingToJSON(value?: ScreenerSetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'setting_name': value.setting_name,
        'value': value.value,
    };
}

